import React from "react";
import {
  FormGroup,
  InputGroup,
  FormControl,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

import _ from "lodash";
import styles from "./Style.module.scss";

class SkillListDetailView extends React.Component {
  constructor(props) {   
    super(props);
    this._handleChange = this._handleChange.bind(this);
  }

  _handleChange(e) {
    const value = e.target.value;
    this.props.onChange(this.props.option, value);
  }

  

  render() {
    return (
      <FormGroup className={styles.formGroup}>
        <InputGroup>
          <FormControl
            type="text"
            placeholder="Untitled"
            value={this.props.option.name ?? ""}
            onChange={(e) => this._handleChange(e)}
          />

          <InputGroup.Text className={styles.delete}>
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="addMenuTooltip">Delete this option</Tooltip>
              }
            >
              <div
                className={styles.action}
                onClick={() => this.props.onDelete(this.props.option)}
              >
                <i className="paperflite-delete"></i>
              </div>
            </OverlayTrigger>
          </InputGroup.Text>

        </InputGroup>
      </FormGroup>
    );
  }
}

export default SkillListDetailView;
